import BaseFormPage from "../../../base/BaseFormPage.js";
import {
  deleteObjectUseCase,
  getObjectUseCase,
  upsertUseCase,
} from "../../../usecases/object/index.js";
import withRouter from "../../../withRouter.js";
import dialog from "../../../components/Modal/dialog.js";
import FullPageLoader from "../../../components/FullPageLoader/index.js";
import ClientsFormPagePresenter from "./ClientsFormPagePresenter.js";
import ClientsForm from "./components/ClientsForm/ClientsForm.js";
import ClientInfoCard from "./components/ClientInfoCard.js";
import PageHeader from "../../../components/PageHeader/index.js";
import { InfiniteScroll } from "../../../nq-component";
import CardWithHeader from "../../../components/CardWithHeader/index.js";

class ClientsFormPage extends BaseFormPage {
  constructor(props) {
    super(props);
    this.state = {
      object: {},
      progress: false,
    };
    this.presenter = new ClientsFormPagePresenter(
      this,
      getObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase(),
    );
  }

  getCollectionName() {
    return "clients";
  }

  getProvinces(region) {
    this.presenter.getAllProvinces(region);
  }

  getClientId() {
    return this.props.params.clientId;
  }

  // getBusinessType() {
  //   const type = this.props.params.type;
  //   switch (type) {
  //     case "sole":
  //       return "Sole Proprietorship";
  //       break;
  //     case "corp":
  //       return "Corporation";
  //       break;
  //     default:
  //       return undefined;
  //       break;
  //   }
  // }

  onClose() {
    dialog.close();
  }

  discardModal() {
    const message =
      "You have unsaved changes that will be lost if you proceed. Are you sure you want to discard these changes?";
    this.showConfirmDialog(message, "Discard Changes", "DISCARD", "CANCEL")
      .then(() => this.navigateBack())
      .catch(() => {});
  }

  render() {
    const { regions, provinces, progress, object } = this.state;
    const user = this.getCurrentUser();
    // const businessType = this.getBusinessType();
    const isAdmin = this.isAdmin();
    const clientId = this.getClientId();

    const fullAddress = [
      object?.billingRegion,
      object?.billingProvince,
      object?.billingCity,
      object?.billingBarangay,
      object?.billingStreet,
    ]
      .filter(Boolean)
      .join(", ");
    return (
      <>
        <InfiniteScroll className={"p-3 p-xl-4 overflow-auto"}>
          <div className="d-flex flex-column gap-4">
            <>
              {/* Header Section */}
              <PageHeader
                breadcrumb={[
                  { label: "Home", path: "/" },
                  { label: "Clients", path: "/clients" },
                  {
                    label: object?.id ? "Edit Client" : "Add Client",
                  },
                ]}
                object={object}
                list={false}
                backButton
                documentName={"Client"}
                description={`${object?.id ? "Update" : "Enter"} your client details`}
              />

              {object?.id && (
                <CardWithHeader
                  title={object?.name}
                  description={object?.businessType}
                  show={object?.id}
                >
                  <div>
                    <small>{fullAddress || ""}</small>
                  </div>
                </CardWithHeader>
              )}

              {/* Form Card */}
              <div className="bg-white rounded-3 shadow-sm p-3">
                <ClientsForm
                  object={object}
                  onSubmit={this.submitWithPreview.bind(this)}
                  onBack={this.navigateBack.bind(this)}
                  discardModal={this.discardModal.bind(this)}
                  progress={progress}
                  // businessType={businessType}
                  isAdmin={isAdmin && !clientId}
                  hasActualChanges={this.hasActualChanges.bind(this)}
                />
              </div>
            </>
          </div>
        </InfiniteScroll>
        {this.renderPreviewModal()}
      </>
    );
  }
}

export default withRouter(ClientsFormPage);
